import { render } from "./ClaimedAmounts.vue?vue&type=template&id=31d73233"
import script from "./ClaimedAmounts.vue?vue&type=script&lang=js"
export * from "./ClaimedAmounts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__